import { render, staticRenderFns } from "./FeedbackOptionsDetail.vue?vue&type=template&id=8f784d08&scoped=true&"
import script from "./FeedbackOptionsDetail.vue?vue&type=script&lang=js&"
export * from "./FeedbackOptionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackOptionsDetail.vue?vue&type=style&index=0&id=8f784d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f784d08",
  null
  
)

export default component.exports